import { useState, useEffect } from 'react'
import styles from './PromoBanner.module.scss'
import Button from '../Button/Button'

function PromoBanner() {
    const [promoData, setPromoData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        // Относительный путь - работает везде
        fetch('/api/sections/get/promo/list?only_active=true')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`)
                }
                return res.json()
            })
            .then(data => {
                const activePromo = data.promoMaterials?.[0]
                
                if (activePromo) {
                    setPromoData(activePromo)
                }
                setLoading(false)
            })
            .catch(err => {
                setError(err.message)
                setLoading(false)
            })
    }, [])

    if (loading) return null
    if (error) return null
    if (!promoData) return null

    return (
        <section className={styles.promoBanner}>
            <div className={styles.promoBannerContainer}>
                <p className={styles.promoBannerText}>
                    {promoData.text || 'Получите скидку на первый месяц обучения'}
                </p>
                <Button />
                <img
                    src={promoData.img || '/img/stock/promo-image.svg'}
                    alt='Promo'
                    className={styles.promoBannerImg}
                />
            </div>
        </section>
    )
}

export default PromoBanner
